import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import "./CircleMenu.css";
import {
  LockOutlined,
  PieChartOutlined,
  DatabaseOutlined,
  TagOutlined,
} from "@ant-design/icons";

export default class CircleMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  render() {
    return (
      <div id="circularMenu" className="circular-menu">
        <Button
          danger
          className="floating-btn"
          onClick={() =>
            document.getElementById("circularMenu").classList.toggle("active")
          }
        >
          <i className="fa fa-plus" />
        </Button>

        <menu className="items-wrapper">
          <Link to="#" onClick={() => this.props.auth()} className="menu-item">
            <TagOutlined
              className="pb-1"
              style={{ verticalAlign: "middle", fontSize: "16px" }}
            />
          </Link>
          <Link to="#" className="menu-item">
            <DatabaseOutlined
              className="pb-1"
              style={{ verticalAlign: "middle", fontSize: "16px" }}
            />
          </Link>
          <Link to="#" className="menu-item">
            <PieChartOutlined
              className="pb-1"
              style={{ verticalAlign: "middle", fontSize: "16px" }}
            />
          </Link>
          <Link to="#" className="menu-item">
            <LockOutlined
              className="pb-1"
              style={{ verticalAlign: "middle", fontSize: "16px" }}
            />
          </Link>
        </menu>
      </div>
    );
  }
}
